var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgB4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 96,
    viewBox: "0 0 208 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3276_3503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.897 13.5317H25.1034C19.9539 13.5317 15.7793 19.6026 15.7793 27.0915V132.44C15.7793 139.929 19.9539 146 25.1034 146H182.897C188.046 146 192.221 139.929 192.221 132.44V27.0915C192.221 19.6026 188.046 13.5317 182.897 13.5317Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.538 14.2439H24.7448C19.7933 14.2439 15.7793 20.4756 15.7793 28.1628V140.627C15.7793 148.315 19.7933 154.546 24.7448 154.546H182.538C187.489 154.546 191.503 148.315 191.503 140.627V28.1628C191.503 20.4756 187.489 14.2439 182.538 14.2439Z",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0897 29.2001C39.0897 25.2667 35.8785 22.0781 31.9173 22.0781C27.9561 22.0781 24.7449 25.2667 24.7449 29.2001C24.7449 33.1334 27.9561 36.322 31.9173 36.322C35.8785 36.322 39.0897 33.1334 39.0897 29.2001Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7311 29.1999C38.7311 25.4633 35.6805 22.4341 31.9173 22.4341C28.1542 22.4341 25.1035 25.4633 25.1035 29.1999C25.1035 32.9366 28.1542 35.9658 31.9173 35.9658C35.6805 35.9658 38.7311 32.9366 38.7311 29.1999Z",
    stroke: "white",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.607 44.8684H27.6138C26.0294 44.8684 24.7449 46.1439 24.7449 47.7172C24.7449 49.2905 26.0294 50.566 27.6138 50.566H164.607C166.191 50.566 167.476 49.2905 167.476 47.7172C167.476 46.1439 166.191 44.8684 164.607 44.8684Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1035 26.3513H48.4139C46.8294 26.3513 45.5449 27.6268 45.5449 29.2001C45.5449 30.7734 46.8294 32.0489 48.4139 32.0489H77.1035C78.688 32.0489 79.9725 30.7734 79.9725 29.2001C79.9725 27.6268 78.688 26.3513 77.1035 26.3513Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6207 26.3513H87.1448C85.5604 26.3513 84.2759 27.6268 84.2759 29.2001C84.2759 30.7734 85.5604 32.0489 87.1448 32.0489H98.6207C100.205 32.0489 101.49 30.7734 101.49 29.2001C101.49 27.6268 100.205 26.3513 98.6207 26.3513Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2759 56.2634H27.6138C26.0294 56.2634 24.7449 57.5389 24.7449 59.1122C24.7449 60.6855 26.0294 61.961 27.6138 61.961H84.2759C85.8604 61.961 87.1449 60.6855 87.1449 59.1122C87.1449 57.5389 85.8604 56.2634 84.2759 56.2634Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3276_3503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 208,
    height: 146,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4);
export default __webpack_public_path__ + "static/media/b4.3d5bb6881019621dfca1d33694d85d55.svg";
export { ForwardRef as ReactComponent };